export { default as Chip, type ChipProps } from './Chip';
